module.exports = __webpack_public_path__ + "static/media/taysha-marie-canales.1526741d.md";